import React, { useEffect } from 'react';
import SchoolProfileStateLayout from './SchoolProfileStateLayout';
import { resetDocumentMetadata, setDocumentMetadata } from '../../utils/documentMeta';

const COPY = {
  school: {
    code: 'Not found',
    title: 'School profile not found',
    message:
      'The school profile you are looking for may not exist or may no longer be available.',
    documentTitle: 'School profile not found | AtadaBoard',
  },
  page: {
    code: 'Not found',
    title: 'Page not found',
    message: 'The page you are looking for may have moved or is no longer available.',
    documentTitle: 'Page not found | AtadaBoard',
  },
};

/**
 * Friendly not-found page. `variant` is "school" when a public path had no
 * profile, and "page" for reserved or unknown website paths.
 */
const SchoolProfileNotFound = ({ variant = 'school' }) => {
  const copy = COPY[variant] || COPY.school;

  useEffect(() => {
    setDocumentMetadata({
      title: copy.documentTitle,
      description: copy.message,
      robots: 'noindex, follow',
    });
    return resetDocumentMetadata;
  }, [copy.documentTitle, copy.message]);

  return (
    <SchoolProfileStateLayout
      code={copy.code}
      title={copy.title}
      message={copy.message}
      footNote="If a school gave you this link, check the address and try again."
    >
      <a className="sp-btn sp-btn-primary" href="/">
        Go to AtadaBoard
      </a>
    </SchoolProfileStateLayout>
  );
};

export default SchoolProfileNotFound;
